import React from 'react'
import { Smartphone, Check } from 'lucide-react'

interface MobileDeviceStatusProps {
  mobileCameraStream: MediaStream | null | undefined;
  workspaceDetected: boolean;
  handsDetected: boolean;
}

const MobileDeviceStatus: React.FC<MobileDeviceStatusProps> = ({
  mobileCameraStream,
  workspaceDetected,
  handsDetected,
}) => (
  <div className="flex-1 min-h-0 min-w-0 rounded-lg bg-white p-2.5 sm:p-3.5 md:p-4.5">
    {mobileCameraStream ? (
      <div className="flex h-full flex-col">
        <div className="mb-2.5 sm:mb-3.5">
          <div className="flex items-center gap-1.5 sm:gap-2 pb-2 sm:pb-2.5">
            <div className="flex h-6 w-6 sm:h-7 sm:w-7 md:h-4 md:w-4 xl:h-4.5 xl:w-4.5 items-center justify-center rounded-lg bg-blue-50 shrink-0">
              <Smartphone className="h-3.5 w-3.5 sm:h-4 sm:w-4 md:h-4 md:w-4 xl:h-4 xl:w-4 text-blue-600" />
            </div>
            <span className="font-semibold text-[11px] sm:text-xs md:text-[8px] lg:text-[10px] xl:text-[12px] text-slate-900">
              Mobile Device
            </span>
            <div className="ml-auto flex items-center gap-1 sm:gap-1.5">
              <div className="rounded-full bg-emerald-500 h-1.5 w-1.5 sm:h-2 sm:w-2" />
              <span className="font-semibold text-[9px] sm:text-[10px] md:text-[8px] lg:text-[9px] text-emerald-600">Active</span>
            </div>
          </div>
          <div className="h-px bg-slate-200" />
        </div>

        <div className="flex flex-col gap-1.5 sm:gap-2 lg:gap-2.5">
          <div className="flex items-center gap-1.5 sm:gap-2">
            <Check
              className={`shrink-0 transition-colors duration-200 h-4 w-4 sm:h-4.5 sm:w-4.5 md:h-3 md:w-3 xl:h-5 xl:w-5 ${
                workspaceDetected ? 'text-emerald-500' : 'text-slate-300'
              }`}
            />
            <span className="text-[13px] sm:text-xs md:text-[10px] lg:text-[10px] text-slate-600">Laptop visible</span>
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <Check
              className={`shrink-0 transition-colors duration-200 h-4 w-4 sm:h-4.5 sm:w-4.5 md:h-3 md:w-3 xl:h-5 xl:w-5 ${
                handsDetected ? 'text-emerald-500' : 'text-slate-300'
              }`}
            />
            <span className="text-[13px] sm:text-xs md:text-[10px] lg:text-[10px] text-slate-600">Hands visible</span>
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <Check className="shrink-0 text-emerald-500 h-4 w-4 sm:h-4.5 sm:w-4.5 md:h-3 md:w-3 xl:h-5 xl:w-5" />
            <span className="text-[13px] sm:text-xs md:text-[10px] lg:text-[10px] text-slate-600">Battery</span>
          </div>
        </div>
      </div>
    ) : (
      <div className="flex h-full items-center justify-center text-center text-[9px] sm:text-[10px] md:text-xs lg:text-sm text-slate-400">
        <span>AI checks resume once the mobile camera connects.</span>
      </div>
    )}
  </div>
);

export default MobileDeviceStatus;


